/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Open360BusinessLogicRetailersPhysicalProductsBEBrand } from './open360BusinessLogicRetailersPhysicalProductsBEBrand';
import { Open360BusinessLogicRetailersPhysicalProductsBEClassificationCategory } from './open360BusinessLogicRetailersPhysicalProductsBEClassificationCategory';
import { Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink } from './open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink';
import { Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation } from './open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation';
import { Open360BusinessLogicRetailersPhysicalProductsNfcStickerProductItemModel } from './open360BusinessLogicRetailersPhysicalProductsNfcStickerProductItemModel';
import { Open360BusinessLogicRetailersPhysicalProductsPhysicalProductExtraItemModel } from './open360BusinessLogicRetailersPhysicalProductsPhysicalProductExtraItemModel';
import { IProductIngredient } from './products/IProductIngredient';


export interface Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct {
    Title: string;
    Description?: string;
    ShortDescription?: string;
    Brand?: Open360BusinessLogicRetailersPhysicalProductsBEBrand;
    ItemTypeID?: number;
    /**
     * 1 = Male, 2 = Female
     */
    Gender?: Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct.GenderEnum;
    Draft?: boolean;
    NfcStickers?: Array<Open360BusinessLogicRetailersPhysicalProductsNfcStickerProductItemModel>;
    VerificationRequired?: boolean;
    IsInformation?: boolean;
    CurrencyCode?: string;
    CurrencySign?: string;
    ClassificationCategory?: Open360BusinessLogicRetailersPhysicalProductsBEClassificationCategory;
    Variations?: Array<Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation>;
    Extras?: Array<Open360BusinessLogicRetailersPhysicalProductsPhysicalProductExtraItemModel>;
    IngredientList?: IProductIngredient[];
    Links?: Array<Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink>;
    Source?: number;
    Preparation?: string;
    Ingredients?: string;
    FoodPreferences?: Array<number>;
    Allergens?: Array<number>;
    PreOrder?: boolean;
}
export namespace Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct {
    export type GenderEnum = 1 | 2;
    export const GenderEnum = {
        NUMBER_1: 1 as GenderEnum,
        NUMBER_2: 2 as GenderEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct.ts